module.exports = "<main [@routerAnimations]=\"prepareRoute(r)\">\n\t<style></style>\n\t<router-outlet #r=\"outlet\"></router-outlet>\n\t<app-snack-bar></app-snack-bar>\n\t<div class=\"closeDrop\" (click)=\"closeDrop()\"></div>\n\t<app-terms></app-terms>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main